import { getProductIcon } from 'legoland-sdk';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductIcon = _ref => {
  let {
    productId,
    ...props
  } = _ref;
  const Icon = getProductIcon(productId);
  return /*#__PURE__*/_jsx(Icon, {
    ...props,
    "data-sentry-element": "Icon",
    "data-sentry-component": "ProductIcon",
    "data-sentry-source-file": "ProductIcon.tsx"
  });
};